import { render } from "./HelpManagement.vue?vue&type=template&id=6fac9b78&scoped=true"
import script from "./HelpManagement.vue?vue&type=script&lang=js"
export * from "./HelpManagement.vue?vue&type=script&lang=js"

import "./HelpManagement.vue?vue&type=style&index=0&id=6fac9b78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fac9b78"]])

export default __exports__